import { render, staticRenderFns } from "./payToday.vue?vue&type=template&id=b8bef4f4&scoped=true&lang=html&"
import script from "./payToday.vue?vue&type=script&lang=js&"
export * from "./payToday.vue?vue&type=script&lang=js&"
import style0 from "./payToday.vue?vue&type=style&index=0&id=b8bef4f4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8bef4f4",
  null
  
)

export default component.exports